import type { QueryClient } from '@tanstack/react-query'

export async function invalidateAffiliationQueries(
  queryClient: QueryClient,
  ids: { personId: number; organizationId: number },
) {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ['person', ids.personId] }),
    queryClient.invalidateQueries({ queryKey: ['organization-profile', ids.organizationId] }),
    queryClient.invalidateQueries({ queryKey: ['organization-engagement', ids.organizationId] }),
    queryClient.invalidateQueries({ queryKey: ['contacts'] }),
  ])
}
